import CachedIcon from "@mui/icons-material/CachedRounded";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useContainer } from "containers/templateDetail/store";
import * as React from "react";
import useCountries from "stores/useStore/useCountries";
import { SelectButton, SelectValue } from "./index";

const CountyFlagTag = styled("div")(({ theme }) => ({
  display: "block",
  width: 24,
  height: 16,
  backgroundSize: "cover",
}));

export default function DestinationSelect(): React.ReactElement {
  const { data: countries } = useCountries();
  const [activeCountryCode] = useContainer.activeCountryCode();
  const [, setOpen] = useContainer.isSwitchModalOpen();

  const activeCountry = React.useMemo(() => {
    return countries?.find((item) => item.isoNumeric === activeCountryCode);
  }, [countries, activeCountryCode]);

  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <Box sx={{ flex: 1, py: 2, px: 2 }} onClick={handleOpen}>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: (theme) => theme.typography.fontWeightBold }}
      >
        Delivery to
      </Typography>
      <SelectButton>
        <Box
          sx={{
            position: "relative",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            component="img"
            sx={{
              maxWidth: "100%",
              maxHeight: "100%",
            }}
            src={`https://flagcdn.com/w40/${activeCountryCode.toLowerCase()}.png`}
          />
        </Box>
        <SelectValue>{activeCountry?.country}</SelectValue>
        <CachedIcon className="switch-icon" sx={{ ml: "auto", fontSize: 16 }} />
      </SelectButton>
    </Box>
  );
}
